import React from "react";
import FourColFiveStories from "../../../../arrow/components/Rows/FourColFiveStories";
import { object } from "prop-types";
import "./style.m.css";

export const ArrowFourColFiveStories = ({ collection, pageType, isFeaturedImage }) => {
  const config = {
    buttonText: `Read More`,
    showImagePlaceholder: true,
    showReadTime: false,
  };
  return (
    <div styleName="four-col-five-stories-container">
      <FourColFiveStories
        collection={collection}
        config={config}
        separator={"divider"}
        showMultipleAuthor={true}
        pageType={pageType}
        isFeaturedImage={true}
      />
    </div>
  );
};

ArrowFourColFiveStories.propTypes = {
  collection: object,
};

ArrowFourColFiveStories.storyLimit = 15;
